// Import the functions you need from the SDKs you need

import { initializeApp } from "firebase/app";

import { getDatabase } from "firebase/database";

// TODO: Add SDKs for Firebase products that you want to use

// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration

const firebaseConfig = {
  apiKey: "AIzaSyCe6oKWH7tXdbmXN-dKLC4BEdhNexMkGVk",
  authDomain: "bezoek-registratie-geenen.firebaseapp.com",
  databaseURL:
    "https://bezoek-registratie-geenen-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "bezoek-registratie-geenen",
  storageBucket: "bezoek-registratie-geenen.appspot.com",
  messagingSenderId: "469664188496",
  appId: "1:469664188496:web:f2f024b8b8e34a4192a955",
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);

export const db = getDatabase(
  app,
  "https://bezoek-registratie-geenen-default-rtdb.europe-west1.firebasedatabase.app/"
);
